<template>
  <!-- cms-input -->
  <div :class="[bem.b()]">
    <div :class="bem.e('group')">
      <!-- cms-input-group__prepend -->
      <div v-if="slots.prepend" :class="bem.be('group', 'prepend')">
        <slot name="prepend"></slot>
      </div>

      <div :class="[bem.e('wrapper')]">
        <span v-if="slots.prefixIcon" :class="bem.e('prefix')">
          <slot name="prefixIcon"></slot>
        </span>
        <input
          :type="showPassword ? (passwordVisible ? 'text' : 'password') : type"
          :placeholder="placeholder"
          :disabled="disabled"
          :readonly="readonly"
          v-bind="attrs"
          :class="bem.e('inner')"
          ref="inputRef"
          @input="handleInput"
          @change="handleChage"
          @blur="handleBlur"
          @focus="handleFocus"
        />
        <span v-if="slots.suffixIcon" :class="bem.e('suffix')">
          <slot name="suffixIcon"></slot>
          <cms-icon v-if="showPwdVisible" @click="handlePasswordVisible" style="line-height: 16px;font-weight: 700;">
            e
          </cms-icon>
          <cms-icon v-if="showClearVisible" @click="handleClearVisible" style="line-height: 16px;font-weight: 700;">
            x
          </cms-icon>
        </span>
      </div>

      <div v-if="slots.append" :class="bem.be('group', 'append')">
        <slot name="append"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  useAttrs,
  useSlots,
  watch,
  ref,
  onMounted,
  nextTick,
  computed,
  inject
} from 'vue'
import { createNamespace } from '@chenms-zj/utils/create'
import { inputEmits, inputProps } from './input'
import { formItemContextKey } from '../../form/src/form-item'

const fromItemContext = inject(formItemContextKey)
defineOptions({
  name: 'cms-input',
  inheritAttrs: false
})

const props = defineProps(inputProps)
const emit = defineEmits(inputEmits)

const slots: any = useSlots()
const attrs = useAttrs()

const bem = createNamespace('input')

watch(
  () => props.modelValue,
  () => {
    fromItemContext?.validate('change').catch(() => {})
    setNativeInputValue()
  }
)

const inputRef = ref<HTMLInputElement | null>(null)
const setNativeInputValue = () => {
  if (!inputRef.value) {
    return
  }

  inputRef.value.value = String(props.modelValue)
}

const handleInput = (e: Event) => {
  const value = (e.target as HTMLInputElement).value
  emit('input', value)
  emit('update:modelValue', value)
}

const handleChage = (e: Event) => {
  const value = (e.target as HTMLInputElement).value
  emit('change', value)
}

const handleFocus = (e: FocusEvent) => {
  emit('focus', e)
}

const handleBlur = (e: FocusEvent) => {
  fromItemContext?.validate('blur').catch(() => {})
  emit('blur', e)
}

const passwordVisible = ref(false)

const focus = async () => {
  await nextTick() // 重新获取焦点
  inputRef.value?.focus()
}

const handlePasswordVisible = () => {
  passwordVisible.value = !passwordVisible.value
  focus()
}

const handleClearVisible = () => {
  emit('input', '')
  emit('update:modelValue', '')
  emit('clear')
  focus()
}

const showPwdVisible = computed(() => {
  return (
    props.modelValue && props.showPassword && !props.disabled && !props.readonly
  )
})

const showClearVisible = computed(() => {
  return (
    props.modelValue && props.clearable && !props.disabled && !props.readonly
  )
})

onMounted(() => {
  setNativeInputValue()
})
</script>

<style scoped></style>
